<template lang="pug">
    .container(ref='animation' v-observe-visibility='visibilityChanged')
        ScrollTrigger(
                :color='theme'
                )
        .header(
            ref='animatedScroll'
            :class='[{fixed: innerBlockPosition === "fixed"}, {bottom: innerBlockPosition === "bottom"}]'

            )
            .header__map-wrap(ref='map')
                img(src='../assets/img/article-header/map.svg', :class='mapColor')
                .city(:style='city.coordinates' :class='city.modifier')
                    .city__dot(ref='dot' :class='city.modifier')
                    span.city__name(v-html='city.name' :class='city.modifier')

            .header__title(v-html='title' ref='title')
        
            .header__next
                span Листайте
        //-ScrollTrigger(
            :color='theme',
            :position='"bottom"'
            )
</template>
<script>
import {gsap} from 'gsap';
import {mixinBigAnimation} from './mixins/mixinBigAnimation';
//import * as basicScroll from 'basicscroll';

export default {
    components: {
        ScrollTrigger: () => import('../components/ScrollTrigger.vue')
    },
    data() {
        return {
            innerBlockPosition: 'top'
        };
    },
    props: {
        title: String,
        city: Object,
        theme: String,
        mapColor: String
    },
    mixins: [mixinBigAnimation],
    methods: {
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .set(this.$refs.map, {opacity: '0'})
                .set(this.$refs.title, {opacity: '1'})
                .set(this.$refs.dot, {scale: '0'})
                .fromTo(this.$refs.map, {opacity: '0'}, {duration: 3, opacity: '1'}, '0')
                .fromTo(this.$refs.title, {opacity: '1'}, {duration: 3, opacity: '0'}, '0')
                .fromTo(this.$refs.dot, {scale: '0'}, {duration: 3, scale: '1'}, '0');

            this.timeline.progress(0.0001);
        },
        createAnimation() {
            this.innerBlockPosition = 'fixed';
            this.blockPositioning();
            this.createTimeline();
            this.createScroll('top-top', 'bottom-bottom');
        }
    },

    beforeDestroy() {
        this.destroyAnimation();
    }
    /*mounted() {
        document.addEventListener('scroll', this.scrollHandler);
        this.createAnimation();
    },*/
};
</script>
<style lang="scss" scoped>
@import '../assets/css/vars.scss';

.container {
    height: 200vh;
    // height: calc(var(--vh) * 300);
    position: relative;
    background-color: #555;

    @media screen and (--viewport-tablet) {
        height: 200vh;
    }
}

.header {
    position: relative;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    // height: calc(var(--vh) * 100);
    background-color: var(--theme);
    display: flex;
    @media screen and (--viewport-tablet) {
        padding: 28px 0;
    }
    @media screen and (--viewport-mobile-lp) {
        padding: 28px 0;
    }

    @media screen and (--viewport-tablet) {
        width: 100vw;
    }

    &__map-wrap {
        opacity: 0;
        will-change: opacity;
        width: var(--grid-width);
        margin: auto;
        position: relative;

        img {
            @media screen and (--viewport-tablet) {
                width: 100%;
                height: auto;
            }
            @media screen and (--viewport-mobile-lp) {
                height: 100%;
                width: auto;
            }
        }
        @media (--viewport-laptop) {
            width: 100%;
        }

        @media screen and (--viewport-tablet) {
            height: fit-content;
            width: 100%;
            //padding: 28px 0;
        }
        @media screen and (--viewport-mobile-lp) {
            width: fit-content;
            height: 100%;
            //padding: 28px 0;
        }
    }

    &__title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-family: var(--font-accent);
        font-weight: 800;
        font-size: 9.72vw;
        line-height: 110%;
        text-align: center;
        opacity: calc(1 - var(--opacity));
        will-change: opacity;
    }

    &.fixed {
        position: fixed;
        top: 0;
        left: 0;
    }

    &.bottom {
        bottom: 0;
        top: auto;
    }

    &__next {
        position: absolute;
        //bottom: 50px;
        top: calc(var(--vh) * 95);
        width: 100%;
        left: 0;
        color: black;
        text-align: center;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: bold;

        @media (--viewport-tablet) {
            bottom: unset;
            top: 85vh;
            top: calc(var(--vh) * 85);
        }

        span {
            &:after {
                content: '▼';
                display: inline-block;
                margin-left: 5px;
            }
        }
    }
}

.city {
    position: absolute;
    display: flex;
    align-items: center;
    width: fit-content;

    &__dot {
        transform-origin: center;
        height: 1rem;
        width: 1rem;
        border-radius: 50%;
        background-color: var(--theme);
        margin-right: 10px;
        transform: scale(0);
        will-change: transform;

        &.reverse {
            margin-left: 10px;
            margin-right: 0;
        }
    }

    &__name {
        font-family: var(--font-main);
        font-weight: bold;
        font-size: 0.75rem;
        line-height: 0.75rem;
        text-transform: uppercase;
        color: var(--theme);

        &.reverse {
            order: -1;
        }
    }
}
</style>
